import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getComparedUsersList } from "../../services/users";

export const useCompareUsersList = (compareData: any[], openModal: boolean) => {
  const { i18n } = useTranslation();
  const compareIds = compareData.map((el: any) => el.id).join(",");

  const {
    data: compareUsersList,
    isLoading: isCompareUsersListLoading,
    isError: isCompareUsersListHasError,
  } = useQuery({
    queryKey: ["Compare", i18n.language, compareIds],
    queryFn: async () => await getComparedUsersList(compareIds),
    enabled: openModal,
  });

  return { compareUsersList, isCompareUsersListLoading, isCompareUsersListHasError };
};
